module.exports = __webpack_public_path__ + "static/house_render_2-71b8e1132485ac49886cfff1325e37c2.jpg";